<div class="switch-container" [class.on]="isToggledOn">
  <div class="switch"></div>
</div>
